interface GetCurrencySymbolOptions {
  userLang?: string | null;
  currencyCode?: string | null;
}

export default function getCurrencySymbol({ userLang, currencyCode }: GetCurrencySymbolOptions): string | null {
  if (userLang && currencyCode) {
    const currencySymbol = new Intl.NumberFormat(userLang, {
      style: 'currency',
      currency: currencyCode,
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency');

    return currencySymbol?.value ?? null;
  }
  return null;
}
